import { createAsyncThunk } from '@reduxjs/toolkit';
import documentMetadataService from 'services/documentMetadataService';

export const updateDocumentMetadata = createAsyncThunk('documentMetadata/update', async ({ id, body }: { id: string; body: object }) => {
  return documentMetadataService.updateDocumentMetadata(id, body);
});

export const archiveDocumentMetadata = createAsyncThunk('documentMetadata/archive', async (id: string) => {
  await documentMetadataService.archiveDocumentMetadata(id);
  return { id };
});

export const unarchiveDocumentMetadata = createAsyncThunk('documentMetadata/unarchive', async (id: string, { rejectWithValue }) => {
  try {
    return await documentMetadataService.unarchiveDocumentMetadata(id);
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteAllArchived = createAsyncThunk('documentMetadata/deleteAll', async () => {
  return documentMetadataService.deleteAllArchived();
});

export const deleteDocumentMetadata = createAsyncThunk('documentMetadata/delete', async (id: string) => {
  await documentMetadataService.deleteDocumentMetadata(id);
  return { id };
});

export const removeApplicationTag = createAsyncThunk(
  'documentMetadata/removeApplicationTag',
  async ({ id, domain, appTagId, type }: { id: string; domain?: string; appTagId?: string; type?: string }) => {
    await documentMetadataService.removeApplicationTag(id, domain, appTagId);
    return { id, type };
  }
);
